import { InjectionToken } from '@angular/core';
import { PrApiSettings } from './pr-api-settings';

export const PR_API_SETTINGS = new InjectionToken<PrApiSettings>('PR_API_SETTINGS');
